declare const window: { matchMedia?: (Query: string) => { matches: unknown } };

/** Browser capability probe; callers own their fallback and fault reporting. */
export class kMediaQuery {
    /** DOCUMENTED EXCEPTION: habitat probe deliberately rethrows to the caller's error boundary.
     * Missing browser capabilities are normal and return false; a failed probe is not a negative match. */
    public static Matches = (Query: string): boolean => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") { return false; }
        return window.matchMedia(Query).matches === true;
    };
}
